module.exports = __webpack_public_path__ + "img/gray-gift-linear-24x24.d6c03a34.svg";